import { ChevronDown, ChevronUp, ChevronsUpDown } from 'lucide-react';

/**
 * Clickable table header that toggles column sort.
 */
export default function SortableTh({
    columnKey,
    sortKey,
    sortDir,
    onSort,
    children,
    className = '',
    align = 'left',
    style,
    title,
}) {
    const active = sortKey === columnKey;
    const ariaSort = active ? (sortDir === 'asc' ? 'ascending' : 'descending') : 'none';
    const justify = align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start';
    const label = typeof children === 'string' ? children : columnKey;

    return (
        <th
            className={`sortable-th ${className}`.trim()}
            style={style}
            aria-sort={ariaSort}
            scope="col"
            title={title}
        >
            <button
                type="button"
                className="sortable-th-btn"
                style={{ justifyContent: justify }}
                onClick={() => onSort?.(columnKey)}
                aria-label={`Ordenar por ${label}`}
            >
                <span>{children}</span>
                <span className={`sortable-th-icon ${active ? 'is-active' : ''}`} aria-hidden>
                    {active
                        ? (sortDir === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />)
                        : <ChevronsUpDown size={14} />}
                </span>
            </button>
        </th>
    );
}
